export default function isRTL() {
  return window.direction === 'rtl';
}
